/**
 * Flags de configuración de la interfaz controlables por despliegue
 * (variables VITE_* horneadas en el build). Un solo lugar para los ajustes
 * de visibilidad que Operación puede necesitar revertir sin cambiar lógica.
 */

/**
 * RF-01 (AjustesPreLibera): visibilidad de la lista de "Signatarios
 * autorizados" (ingenieros/asociados del laboratorio) durante la captura de
 * solicitudes de Telecom (Nuevo Certificado y Reexpedición).
 *
 * Por defecto OCULTA para la operación diaria. Los signatarios se siguen
 * asociando internamente —todos los del laboratorio+norma— y el certificado
 * se genera igual; esto SOLO controla si la lista se dibuja en pantalla.
 *
 * Para volver a mostrarla (p. ej. durante una auditoría), definir en el
 * entorno de build y redesplegar:
 *
 *     VITE_TELECOM_MOSTRAR_SIGNATARIOS=true
 */
export const MOSTRAR_SIGNATARIOS_TELECOM =
  import.meta.env.VITE_TELECOM_MOSTRAR_SIGNATARIOS === "true";
